module.exports = __webpack_public_path__ + "media/images/icons/flags/MC-917c26440cc09fa3d32960e020b272b1.svg";